import React from 'react';
import { RelayMigrationProvider } from '@atlassian/jira-relay-apollo-migration-utils';
import { DeploymentProviderServiceQueryResultProvider } from './services/deployment-provider';
import { ProjectIdProvider } from './services/get-project';
import DeploymentFrequencyReportWithoutApolloProvider from './ui';
import DeploymentFrequencyDataAnalyticsWrapper from './ui/deploymentfrequency-data-analytics-wrapper';

const DeploymentFrequencyReport = () => (
	<RelayMigrationProvider>
		<ProjectIdProvider>
			<DeploymentProviderServiceQueryResultProvider>
				<DeploymentFrequencyDataAnalyticsWrapper>
					<DeploymentFrequencyReportWithoutApolloProvider />
				</DeploymentFrequencyDataAnalyticsWrapper>
			</DeploymentProviderServiceQueryResultProvider>
		</ProjectIdProvider>
	</RelayMigrationProvider>
);

export default DeploymentFrequencyReport;

export {
	useViewDeploymentFrequencyReportExperienceFail,
	ViewDeploymentFrequencyReportExperienceStart,
	ViewDeploymentFrequencyReportExpectedErrorExperienceSuccessTracker,
} from './services/experience-tracker';
